import React, { FC } from 'react';

import { ArticleType, Dates } from '@domains/article';

import { formatDate, formatRangeDate } from '@utils/date';
import { isValueSet } from '@utils/guards';

type ArticleDatesRangeProps = {
    dates: Dates;
    type: ArticleType;
};
export const ArticleDatesRange: FC<ArticleDatesRangeProps> = (props) => {
    const { dates, type } = props;

    if (type === 'news' && isValueSet(dates.published_at)) {
        return (
            <time dateTime={dates.published_at.toString()}>
                {formatDate(new Date(dates.published_at))}
            </time>
        );
    }

    if (type === 'promotion' && isValueSet(dates.starts_at)) {
        return (
            <time dateTime={dates.starts_at.toString()}>
                {formatRangeDate(
                    new Date(dates.starts_at),
                    isValueSet(dates.ends_at) ? new Date(dates.ends_at) : null,
                )}
            </time>
        );
    }

    return null;
};
